import { ButtonModule } from "primeng/button";
import { ClinicHealthRecordMetaStore } from '../../store/clinic-health-record-meta.store';
import { ClinicSiteFooterComponent } from '../clinic-site-footer/clinic-site-footer.component';
import { ClinicSiteHeaderComponent } from '../clinic-site-header/clinic-site-header.component';

import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Drawer, DrawerModule } from 'primeng/drawer';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import { GlobalStore } from '@web/csl-lib-store';
import { HealthRecordBreadcrumbComponent } from './health-record-breadcrumb/health-record-breadcrumb.component';
import { HelpService } from '@web/csl-lib-services';
import { NonProdBannerComponent } from '@web/csl-lib-components';
import { ProgressBarModule } from "primeng/progressbar";
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from "primeng/table";
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-clinic-health-record-layout',
  standalone: true,
  imports: [
    ButtonModule,
    ClinicSiteFooterComponent,
    ClinicSiteHeaderComponent,
    Drawer,
    DrawerModule,
    FormsModule,
    HealthRecordBreadcrumbComponent,
    ProgressBarModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    SelectButtonModule,
    TableModule,
    ToastModule,
    NonProdBannerComponent
],
  templateUrl: './health-record-layout.component.html',
  styleUrl: './health-record-layout.component.css',
  providers: [GlobalStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HealthRecordLayoutComponent implements OnInit {
  // The HealthRecordLayoutComponent is the entry point to a health record, therefore the health record id is captured using
  // Route Input Binding, and then, in ngOnInit(), stored in the GlobalStore for use by other components
  healthRecordId = input<string>();

  /* Store */

  readonly globalStore = inject(GlobalStore);
  readonly clinicHealthRecordMetaStore = inject(ClinicHealthRecordMetaStore);

  /* Services */

  helpService = inject(HelpService);

  /* Member Vars */

  isUserOwner = computed(() => {
    if (
      this.clinicHealthRecordMetaStore.healthRecordMeta() === null ||
      this.globalStore.loggedInUser() === null
    ) {
      return false;
    }
    return (
      this.clinicHealthRecordMetaStore.healthRecordMeta()!.ownerUserId ===
      this.globalStore.loggedInUser()!.survivorLinkId
    );
  });
  showHelp = computed(() => this.helpService.helpContent() !== null);

  /* Lifecycle Hooks */

  ngOnInit() {
    // Set health record id that was passed in as input from the route, then load the health record meta data
    this.clinicHealthRecordMetaStore.setHealthRecordId(this.healthRecordId()!);
    this.clinicHealthRecordMetaStore.loadHealthRecordMeta(this.healthRecordId()!);
  }

  /* Event Handlers */

  onHelpDrawerHide() {
    this.helpService.clearHelp();
  }

  /* Instance Methods */
  protected readonly environment = environment;
}


